module.exports = __webpack_public_path__ + "static/img/Stagnation-woman.png";